import { toast } from "react-toastify";
import { SVG_ENUM, TOAST_TYPES_ENUM } from "../../enums";
import "./Toast.scss";
import SVG from "../SVG";

interface ToastProps {
  message: string;
  type: TOAST_TYPES_ENUM;
  id: string;
}

const Toast = ({ message, type, id }: ToastProps) => {
  const handleShowToast = () => {
    switch (type) {
      case TOAST_TYPES_ENUM.SUCCESS:
        toast.update(id, {
          render: (
            <div>
              <h2 className="toast-title toast-title--success">Sukces</h2>
              <p>{message}</p>
            </div>
          ),
          type: "success",
          isLoading: false,
          hideProgressBar: true,
          closeButton: true,
          icon: ({ theme, type }) => <SVG type={SVG_ENUM.EP_SUCCESS} />,
          autoClose: 3000,
        });

        break;
      case TOAST_TYPES_ENUM.ERROR:
        toast.update(id, {
          render: (
            <div>
              <h2 className="toast-title toast-title--failure">Błąd</h2>
              <p>{message}</p>
            </div>
          ),
          type: "error",
          isLoading: false,
          closeButton: true,
          autoClose: 3000,
          hideProgressBar: true,
          icon: ({ theme, type }) => <SVG type={SVG_ENUM.EP_FAIL} />,
        });
        break;
      case TOAST_TYPES_ENUM.LOADING:
        toast.loading("Ładowanie", { toastId: id });
        break;
      default: {
        console.error(`Niepoprawny typ notyfikacji (${type})`);
      }
    }
  };

  return <>{handleShowToast()}</>;
};

export default Toast;
